import React from 'react';
import DataDrivenArticlePage from '../components/articles/DataDrivenArticlePage';

const SystemEngineeringProcessTechnicalArticlePage = () => (
  <DataDrivenArticlePage slug="article-system-engineering-process" pdfSlug="system-engineering-process" />
);

export default SystemEngineeringProcessTechnicalArticlePage;
